/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import RangeInput from '../../../../common/RangeInput/RangeInput'
import { symbol } from '../../../../common/CurrencyFormat'

/**
 * Will return the value of the input or the value of the label
 *
 * @param {any} value
 * @returns {number} the value to use
 */
const returnValue = (value) => {
    switch (value) {
        case 0:
            return 500
        case 1:
            return 1000
        case 2:
            return 2500
        case 3:
            return 5000
        case 500:
            return 0
        case 1000:
            return 1
        case 2500:
            return 2
        case 5000:
            return 3
        default:
            return

    }
}

/**
 * Will generate the measurements lines in the layour
 *
 * @param {any} N
 * @returns {ReactDOM}
 */
const generateMeasurements = (N) => {
    let array = Array.apply(null, { length: N }).map(Number.call, Number)
    return array.map((item) => {
        return (
            <div className={`measurements museums measurements-excess-${item + 1}`} key={item} />
        )
    })
}

const RateVariationExcess = (props: any) => (
    <div className="adjustment">
        <div className="adjustment__title">Excess:</div>
        <div className="adjustment__range">
            {generateMeasurements(4)}
            <RangeInput
                onChange={(value) => { props.onChange(returnValue(value)) }}
                value={returnValue(props.value)}
                max={3}
                min={0}
            />
        </div>
        <div className="adjustment__result">{symbol()} {props.value}</div>
    </div>
)

export default RateVariationExcess



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05d/components/RateVariationExcess.tsx